var userSubscriptions4i = function(){
	'use strict';	
	
	var emailPrefs, allSaleChecks, allProductChecks, allNewsChecks, allCustCommChecks,
	espAccordions = new getAccordions4i(),
	saleSection = document.getElementById("SaleSection"),
	productSection = document.getElementById("ProductSection"),
	newsSection = document.getElementById("NewsletterSection"),
	custCommSection = document.getElementById("CustomerCommunicationSection"),
	checkAllSales = document.getElementById("SalesCheckAll"),
	checkAllProduct = document.getElementById("ProductCheckAll"),
	checkAllNews = document.getElementById("NewsletterCheckAll"),
	checkAllCustComm = document.getElementById("CustomerCommunicationCheckAll"),
	hasSMS = document.getElementById("SMSAlertsSection"),
	isPublicESP = document.getElementById("hdnEmail"),
	useRecaptcha = document.getElementById("UseRecaptcha"),
	loadingUpdates = '<div id="busyLoading" class="paddingTop20 spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
	var success = false;
	
	if (saleSection) {
		allSaleChecks = [].slice.call(saleSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']"));
	}
	if (productSection) {
		allProductChecks = [].slice.call(productSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']"));
	}
	if (newsSection) {
		if (newsSection.getElementsByTagName('ul').length > 0) {
			allNewsChecks = [].slice.call(newsSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']"));
		}
	}	
	if (custCommSection) {
		if (custCommSection.getElementsByTagName('ul').length > 0) {
			allCustCommChecks = [].slice.call(custCommSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']"));
		}
	}	
	if(hasSMS){
		var SMSSection = document.getElementById("SMSAlertsSection");
		var allSMSChecks = [].slice.call(SMSSection.getElementsByTagName('ul')[0].querySelectorAll("input[type='checkbox']"));
		var checkAllSMS = document.getElementById("SMSAlertsCheckAll");
	}	
	if(isPublicESP){
		var emailAddress = document.getElementById("hdnEmail").textContent.toString();
		var userID = document.getElementById("hdnUserID").textContent.toString();
	}
	
	var addCheckboxEvents = function(){
		function checkUncheckAll(trigger, allCheckBoxes){
			trigger.addEventListener('click', function(e){
				if (trigger.checked){
					allCheckBoxes.forEach(function(el, index, array) {
						el.checked = true;
					});	
				} else{
					allCheckBoxes.forEach(function(el, index, array) {
						el.checked = false;
					});	
				}
		 	});
		}
		if (checkAllSales && allSaleChecks) {
			checkUncheckAll(checkAllSales, allSaleChecks);
		}
		if (checkAllProduct && allProductChecks) {
			checkUncheckAll(checkAllProduct, allProductChecks);
		}
		if (checkAllNews && allNewsChecks) {
			checkUncheckAll(checkAllNews, allNewsChecks);
		}
		if (checkAllCustComm && allCustCommChecks) {
			checkUncheckAll(checkAllCustComm, allCustCommChecks);
		}
		if(hasSMS) {
			if (checkAllSMS && allSMSChecks) {
				checkUncheckAll(checkAllSMS, allSMSChecks); 
			}
		}
	},
	updateCheckboxes = function(){
		var SaleAllChecked = true;
		var ProductAllChecked = true;
		var NewsletterAllChecked = true;
		var CustCommAllChecked = true;
		var SMSAllChecked;
		if(hasSMS){ SMSAllChecked = true; }
		
		function checking(allCheckBoxes, truthy, triggerAll){
			allCheckBoxes.forEach(function(el, index, array) {
				if(el.value != ''){
					if(el.checked == false){
						truthy = false;
					}
				}
				el.addEventListener('click', function(){
					if(el.checked == false){
						triggerAll.checked = false;
					}
				});
			});
			return truthy;
		}
		if (allSaleChecks && checkAllSales) {
			SaleAllChecked = checking(allSaleChecks, SaleAllChecked, checkAllSales);
		}
		if (allProductChecks && checkAllProduct) {
			ProductAllChecked = checking(allProductChecks, ProductAllChecked, checkAllProduct);
		}
		if (allNewsChecks && checkAllNews) {
			NewsletterAllChecked = checking(allNewsChecks, NewsletterAllChecked, checkAllNews);
		}
		if (allCustCommChecks && checkAllCustComm) {
			CustCommAllChecked = checking(allCustCommChecks, CustCommAllChecked, checkAllCustComm)
		}

		if(hasSMS){ SMSAllChecked = checking(allSMSChecks, SMSAllChecked, checkAllSMS); }
		
		if(SaleAllChecked && checkAllSales){ checkAllSales.checked = true; }
		if(ProductAllChecked && checkAllProduct){ checkAllProduct.checked = true; }
		if(NewsletterAllChecked && checkAllNews){ checkAllNews.checked = true; }
		if(CustCommAllChecked && checkAllCustComm){ checkAllCustComm.checked = true; }
		if(hasSMS){ if(SMSAllChecked && checkAllSMS){ checkAllSMS.checked = true; } }
	},
	showLoading = function(){
		var actionBtns = document.getElementById("SaveChanges");
		if (actionBtns) {
			actionBtns.insertAdjacentHTML('afterend', loadingUpdates);
		}
	},
	hideLoading = function(){
		if (document.getElementById("busyLoading")) {
			document.getElementById("busyLoading").parentNode.removeChild(document.getElementById("busyLoading"));
		}
	},
	messageAuto = function(msg) {	
		if(document.getElementById("statusMsg")){
			document.getElementById("statusMsg").parentNode.removeChild(document.getElementById("statusMsg"));
		}
		var insertBeforeElement;
		if(isPublicESP){
			insertBeforeElement = document.getElementById("EmailHeader"); // no catalog on public esp
		}else{
			insertBeforeElement = document.getElementById("CatalogHeader");
		}
		insertBeforeElement.insertAdjacentHTML('beforebegin', msg);
		window.scrollTo({
			top: 0,
                	behavior: "smooth"
            	});
		document.getElementById("statusMsg").getElementsByTagName("a")[0].focus();
	},
	successMessage = function(){
		messageAuto("<p id='statusMsg' class='paddingTop10 paddingBtm10' role='alert' aria-atomic='true'><svg class='textDarkestGray roundCorners5 bkgdGreen inlineMiddle' height='30px' width='30px' aria-hidden='true'> <use xlink:href='#svgIcon-checkMark'></use> </svg> <span class='inlineMiddle textSemiBold textBlue text18'>Your subscription preferences have been updated.</span><br /><span class='text16'>Continue to the homepage to <a href='/'>start shopping</a>.</span></p>");
	},
	failureMessage = function(){
		messageAuto("<p id='statusMsg' class='paddingTop10 paddingBtm10' role='alert' aria-atomic='true'> <span class='inlineMiddle textSemiBold textDkRed text18'>Your subscription preferences failed to update.</span><br /><span class='text16'>If this continues please <a href='/info/contactus'>contact us</a> for assistance.</span></p>");
	},
	recaptchaFailureMessage = function(recaptchaError) {
		messageAuto(recaptchaError);
	},
	unCheckAllPrefs = function() {
	        function unCheckAll(elements){
			elements.forEach(function(el, index, array) {
				el.checked = false;
			});
		}
    		if (allSaleChecks) { unCheckAll(allSaleChecks); }
		if (allProductChecks) { unCheckAll(allProductChecks); }
		if (allNewsChecks) { unCheckAll(allNewsChecks); }
		if (allCustCommChecks) { unCheckAll(allCustCommChecks); }
		if(hasSMS && allSMSChecks) { unCheckAll(allSMSChecks); }
		
		if (checkAllSales) { checkAllSales.checked = false; }
		if (checkAllProduct) { checkAllProduct.checked = false; }
		if (checkAllNews) { checkAllNews.checked = false; }
		if (checkAllCustComm) { checkAllCustComm.checked = false;}
		if(hasSMS && checkAllSMS){ checkAllSMS.checked = false; }
	},
	saveChanges = function(){
		showLoading();
		emailPrefs = "";
		function updateThis(elements){
			elements.forEach(function(el, index, array) {
				if(el.value != ''){
					if(el.checked){			
						emailPrefs += el.value + ":true,";
					} else{
						emailPrefs += el.value + ":false,";
					}
				}
			});
		}
	
		if (allSaleChecks) { updateThis(allSaleChecks); }
		if (allProductChecks) { updateThis(allProductChecks); }
		if (allNewsChecks) { updateThis(allNewsChecks); }
		if (allCustCommChecks) { updateThis(allCustCommChecks); }
		// public esp difference - has recaptcha request here unless using Oasis
		if(isPublicESP && useRecaptcha){
			ajaxActions.PublicSaveRequest(emailPrefs);
		}else if(isPublicESP){
			ajaxActions.PublicSaveRequestNoRecaptcha(emailPrefs);
		}else{
			ajaxActions.SaveRequest(emailPrefs);
		}
	},
	ajaxActions = (function(){
		var verificationToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value,
		
		publicUnsubscribeAll = async () => {
			showLoading();
			var emailPrefers = "";
	
			function unsubscribeThis(elements){
				elements.forEach(function(el, index, array) {
					if(el.value != ''){
						if (el.checked) {
							emailPrefers += el.value + ":true,";
						}else {
							emailPrefers += el.value + ":false,";
						}
					}
				});
			}
			if (allSaleChecks) { unsubscribeThis(allSaleChecks); }
			if (allProductChecks) { unsubscribeThis(allProductChecks); }
			if (allNewsChecks) { unsubscribeThis(allNewsChecks); }
			if (allCustCommChecks) { unsubscribeThis(allCustCommChecks); }
			
			var recaptchaSiteKey = document.getElementsByClassName("recaptchaSiteKey")[0].value.toString();
			var recaptchaActionName = document.getElementsByClassName("recaptchaActionName")[0].value.toString();
	
			// Check if grecaptcha is defined
			// if not, try to fetch the script again 
			if(typeof grecaptcha == "undefined" && typeof get4iRecaptcha !== "undefined") await get4iRecaptcha();
			
			// need to show an error if recaptcha script still isn't available
			if(typeof grecaptcha == "undefined"){
				failureMessage();
				hideLoading();
			}else{
				grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName }).then(function(token) {
				        var unsubscribeData = {
						emailPrefs : emailPrefers, 
						emailAddress : emailAddress, 
						userID : userID, 
						useRecaptcha : true, 
						recaptchaActionName : recaptchaActionName, 
						recaptchaToken : token
					};
						        			
					fetch('/Esp/UnsubscribeAllEmails', { 
						method: 'POST', 
						body: JSON.stringify(unsubscribeData), 
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verificationToken, "RequestVerificationToken": verificationToken }
					}).then(function(response){
						return  (response.ok) ? response.json() : []; // response.json() returns a promise
					}).then(function(response){
						if (response.success == "true") {
					    		unCheckAllPrefs();
					    		success = true;
			    				if (hasSMS) {
								unsubscribeSMSAlerts();
							}else {
						    		successMessage();
						    		hideLoading();
					    		}
					    	} else {
					    		success = false;
					    		recaptchaFailureMessage(response.recaptchaError);
					    		hideLoading();
					    	}
					}).catch(function(error){
						success = false;
		    				if (hasSMS) {
							unsubscribeSMSAlerts();
						}else {
					    		failureMessage();
					    		hideLoading();
				    		}
					});
			    	});
			}
		},
		publicUnsubscribeAllNoRecaptcha = function(){
			showLoading();
			var emailPrefers = "";
	
			function unsubscribeThis(elements){
				elements.forEach(function(el, index, array) {
					if(el.value != ''){
						if (el.checked) {
							emailPrefers += el.value + ":true,";
						}else {
							emailPrefers += el.value + ":false,";
						}
					}
				});
			}
			if (allSaleChecks) { unsubscribeThis(allSaleChecks); }
			if (allProductChecks) { unsubscribeThis(allProductChecks); }
			if (allNewsChecks) { unsubscribeThis(allNewsChecks); }
			if (allCustCommChecks) { unsubscribeThis(allCustCommChecks); }
			var unsubscribeData = {
				emailPrefs : emailPrefers, 
				emailAddress : emailAddress, 
				userID : userID
			};
			
			fetch('/Esp/UnsubscribeAllEmails', { 
				method: 'POST', 
				body: JSON.stringify(unsubscribeData), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verificationToken, "RequestVerificationToken": verificationToken }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; 
			}).then(function(response){
				unCheckAllPrefs();
		    		success = true;
    				if (hasSMS) {
					unsubscribeSMSAlerts();
				}else {
			    		successMessage();
			    		hideLoading();
		    		}
			}).catch(function(error){
				success = false;
    				if (hasSMS) {
					unsubscribeSMSAlerts();
				}else {
			    		failureMessage();
			    		hideLoading();
		    		}
			}); 
		},
		unsubscribeAll = function(){
			showLoading();
				        			
			fetch('/Esp/UnsubscribeAllEmailsExcludeBlueBox', { 
				method: 'POST', 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verificationToken, "RequestVerificationToken": verificationToken }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; 
			}).then(function(response){
				unCheckAllPrefs();
				success = true;
				if (hasSMS) {
					unsubscribeSMSAlerts();
				}else {
		          		successMessage();
		          		hideLoading();
	          		}
	          		unsubscribeCatalog();
			}).catch(function(error){
				success = false;
		    		if (hasSMS) {
		    			unsubscribeSMSAlerts();
		    		}else {
			    		failureMessage();
			    		hideLoading();
		    		}
			}); 
		},
		saveRequest = function(prefs){	        			
			fetch('/Esp/SaveEmailSubscriptionsExcludeBlueBox', { 
				method: 'POST', 
				body: JSON.stringify({ emailPrefs: prefs }), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verificationToken, "RequestVerificationToken": verificationToken }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; 
			}).then(function(response){
				success = true;
		    		if (hasSMS) {
		    			updateSMSAlertsPreferences();
		    		}else {
		    			successMessage();
		    			hideLoading();
		    		}
		    		updateCatalogPreference();
			}).catch(function(error){
				success = false;
		    		if (hasSMS) {
		    			updateSMSAlertsPreferences();
		    		}else {
			    		failureMessage();
			    		hideLoading();
		    		}
			});
		},
		publicSaveRequest = async (prefs) => {
			var recaptchaSiteKey = document.getElementsByClassName("recaptchaSiteKey")[0].value.toString();
			var recaptchaActionName = document.getElementsByClassName("recaptchaActionName")[0].value.toString();
			
			// Check if grecaptcha is defined
			// if not, try to fetch the script again 
			if(typeof grecaptcha == "undefined" && typeof get4iRecaptcha !== "undefined") await get4iRecaptcha();
			
			// need to show an error if recaptcha script still isn't available
			if(typeof grecaptcha == "undefined"){
				failureMessage();
				hideLoading();
			}else{
			    	grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName }).then(function(token) {
			        	var saveUserData = {
						emailPrefs : prefs, 
						emailAddress : emailAddress,
						userID : userID, 
						useRecaptcha : true, 
						recaptchaActionName : recaptchaActionName,
						recaptchaToken : token
					};
						        			
					fetch('/Esp/SavePublicUserSubscriptions', { 
						method: 'POST', 
						body: JSON.stringify(saveUserData), 
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verificationToken, "RequestVerificationToken": verificationToken }
					}).then(function(response){
						return  (response.ok) ? response.json() : []; // response.json() returns a promise
					}).then(function(response){
						if (response.success == "true") {
					    		success = true;
			    				if (hasSMS) {
								updateSMSAlertsPreferences();
							}else{
						    		successMessage();
						    		hideLoading();
						    	}
					    	} else {
					    		success = false;
					    		recaptchaFailureMessage(response.recaptchaError);
					    		hideLoading();
					    	}
					}).catch(function(error){
						success = false;
		    				if (hasSMS) {
							updateSMSAlertsPreferences();
						}else{
					    		failureMessage();
					    		hideLoading();
					    	}
					});
			    	});
			 }
		},
		publicSaveRequestNoRecaptcha = function(prefs){
			var saveUserData = {
				emailPrefs : prefs, 
				emailAddress : emailAddress,
				userID : userID
			};
				        			
			fetch('/Esp/SavePublicUserSubscriptions', { 
				method: 'POST', 
				body: JSON.stringify(saveUserData), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verificationToken, "RequestVerificationToken": verificationToken }
			}).then(function(response){
				return  (response.ok) ? response.json() : [];
			}).then(function(response){
				success = true;
    				if (hasSMS) {
					updateSMSAlertsPreferences();
				}else{
			    		successMessage();
			    		hideLoading();
			    	}
			}).catch(function(error){
				success = false;
    				if (hasSMS) {
					updateSMSAlertsPreferences();
				}else{
			    		failureMessage();
			    		hideLoading();
			    	}
			});
		},
		unsubscribeSMSAlerts = function() {
			var unsubscribeSMS;
			if(isPublicESP){		        			
				fetch('/Esp/UnsubscribeAllSMSAlerts', { 
					method: 'POST', 
					body: JSON.stringify({ emailAddress : emailAddress }), 
					headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verificationToken, "RequestVerificationToken": verificationToken }
				}).then(function(response){
					return  (response.ok) ? response.text() : []; 
				}).then(function(response){
					if (success) { successMessage(); }
			    		else { failureMessage(); }
			    		hideLoading();
				}).catch(function(error){
					failureMessage();
		    			hideLoading();
				});
			}else{
				fetch('/Esp/UnsubscribeAllSMSAlerts', { 
					method: 'POST', 
					headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verificationToken, "RequestVerificationToken": verificationToken}
				}).then(function(response){
					return  (response.ok) ? response.text() : []; 
				}).then(function(response){
					if (success) { successMessage(); }
			    		else { failureMessage(); }
			    		hideLoading();
				}).catch(function(error){
					failureMessage();
		    			hideLoading();
				});
			}
		},
		updateCatalogCheckbox = function() {
		    	if(document.getElementById("registerForm")){
				document.getElementById('CatalogCheckbox').checked = true;
			}else { 
				document.getElementById('CatalogCheckbox').checked = false;
			}
				        			
			fetch('/Catalog/CatalogSubscription', { 
				method: 'GET', 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; // response.json() returns a promise
			}).then(function(response){
				if (response === 'True') {
					document.getElementById('CatalogCheckbox').checked = true;
				}
			}).catch(function(error){
				// place error handling here
			});
		},
		updateSMSAlertsPreferences = function() {
			var smsPrefs = "";
			allSMSChecks.forEach(function(el, index, array) {
				if(el.value != ''){
					if(el.checked){			
						smsPrefs += el.value + ":true,";
					} else{
						smsPrefs += el.value + ":false,";
					}
				}
			});
			
			var SMSdata;
			if(isPublicESP){
				SMSdata = { smsPrefs : smsPrefs, emailAddress : emailAddress };
			}else{
				SMSdata = { smsPrefs : smsPrefs };
			}
				        			
			fetch('/Esp/SaveSMSSubscriptions', { 
				method: 'POST', 
				body: JSON.stringify(SMSdata), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verificationToken, "RequestVerificationToken": verificationToken}
			}).then(function(response){
				return  (response.ok) ? response.text() : []; 
			}).then(function(response){
				if (success) { successMessage(); }
		    		else { failureMessage(); }
		    		hideLoading();
			}).catch(function(error){
				failureMessage();
		    		hideLoading();
			}); 
		},
		updateCatalogPreference = function() {
			var url = "";
	
		       if (document.getElementById('CatalogCheckbox').checked == true) {
				url = "/Catalog/SubscribeCatalogSubscription";
		       } else {
		            	url = "/Catalog/UnsubscribeCatalogSubscription";
		       }
		       	        			
			fetch(url, { 
				method: 'POST', 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verificationToken, "RequestVerificationToken": verificationToken }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; // response.json() returns a promise
			}).then(function(response){
				// proceed after successful request
			}).catch(function(error){
				// place error handling here
			});
		},
		unsubscribeCatalog = function() {
			fetch('/Catalog/UnsubscribeCatalogSubscription', { 
				method: 'POST', 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verificationToken, "RequestVerificationToken": verificationToken }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; // response.json() returns a promise
			}).then(function(response){
				document.getElementById('CatalogCheckbox').checked = false;
			}).catch(function(error){
				// place error handling here
			});
		};
		return{
			PublicUnsubscribeAll: publicUnsubscribeAll,
			PublicUnsubscribeAllNoRecaptcha: publicUnsubscribeAllNoRecaptcha,
			UnsubscribeAll: unsubscribeAll,
			SaveRequest: saveRequest,
			PublicSaveRequest: publicSaveRequest,
			PublicSaveRequestNoRecaptcha: publicSaveRequestNoRecaptcha,
			UpdateCatalogCheckbox: updateCatalogCheckbox
		};
	})(),
	
	init = function(){
		if(document.getElementById("SaveChanges")){
	    		document.getElementById("SaveChanges").addEventListener("click", function(e) { 
				e.preventDefault();
				saveChanges();
			});
		
	    	}
		if(document.getElementById("UnsubscribeAll")){
			document.getElementById("UnsubscribeAll").addEventListener("click", function(e) { 
				e.preventDefault();
				if(isPublicESP && useRecaptcha){
					ajaxActions.PublicUnsubscribeAll();
				}else if(isPublicESP){
					ajaxActions.PublicUnsubscribeAllNoRecaptcha();
				}else{
					ajaxActions.UnsubscribeAll();
				}
			});
		}
	    	
	    	if(!isPublicESP){ // not called on public esp page
	    		ajaxActions.UpdateCatalogCheckbox();
	    	}
		updateCheckboxes();
		addCheckboxEvents();
		espAccordions.init(document.getElementById("mainContent"));
	};

	return {
		init: init	
	};
};

(function(){
	var userPreferences4i = new userSubscriptions4i();
	userPreferences4i.init();
})();